import { graphql } from "../generated";

export const GetCustomSummaryResults = graphql(
  `
    query GetCustomSummaryResults($input: GetCustomSummaryResultsInput) {
      getCustomSummaryResults(input: $input) {
        ... on GetCustomSummaryResultsResult {
          __typename
          items {
            ...CustomSummaryResult
          }
          pageInfo {
            currentToken
            limit
            nextToken
            previousToken
            total
          }
        }
        ... on GenericException {
          ...BaseException
        }
        ... on UserInputException {
          ...UserInputException
        }
      }
    }
  `
);
